const state = {
  menu:[
    { class: 'tv_router', link: 'https://arkincasinotv.live/', title: 'Maç İzle'},
  ],
  configSpesific:{
    autoBonus:false,
    discountRequestSite:false,
  },
  bonusUrl:'https://payment.wlbonustalep.com/arkin?username=',
  footerProviders:['creditcard','papara','pf_manuel','minihavale','instant_kk', 'instant_mft', 'instant_bank','tether_deposit','btc_deposit'],
  homePayments:['instant_bank','papara','envoy','crypto','creditcard']
}
const getters = {
  getConfigSpesific(state){
    return state.configSpesific
  },
  getMenu(state){
    return state.menu
  },
  bonusUrl(state){
    return state.bonusUrl
  },
  getHomePayments(state){
    return state.homePayments
  },
  footerProviders(state){
    return state.footerProviders
  }
}
export default {
  namespaced: true,
  state,
  getters,
}